module.exports = __webpack_public_path__ + "static/media/app_logo.e4733c7b.png";